import React from "react";
import "./PolarianALMSolutionPage.css";
import BannerImage from "../../../assets/other_image/polarian.jpg";
import PolarianALMSolutionOverview from "./PolarianALMSolutionOverview";
import Letsgetintouch from "../../PLMImplementation/BusinessProcessAndChangeManagement/Letsgetintouch";
import Banner from "../SolutionBanner/Banner";
import FloatingContactUs from "../../floting_contact/FloatingContactUs";

const PolarianALMSolutionPage = () => {
  return (
    <section className="PolarianALMSolution-process">
      <Banner
        image={BannerImage} // Pass the image for this page
        heading="Polarian ALM Solutions" // Pass the heading text for this page
      />
      <FloatingContactUs />

      <PolarianALMSolutionOverview />

      <section style={{ background: "#f5f7fa" }}>
        <div className="benefits container">
          <h4 className="solution-page-heading">Unlock the Power :</h4>
          <h5 className="solution-subheading">
            Discover the Transformative Benefits of Polarian ALM Solutions with NexTech!
          </h5>

          <div className="polarian-benifits">
            <h5>ALM AS Saas </h5>
            <ul className="custom-bullets">
              <li>
                Facilitates real-time decision-making for quick, informed
                choices.
              </li>
              <li>
                Improves development speed and agility, enhancing flexibility.{" "}
              </li>
              <li>
                Ensures high quality and compliance with regulatory standards.
              </li>
              <li>
                Helps enterprises plan more efficiently, optimizing resource
                allocation.
              </li>
              <li>
                Strengthens testing practices, enhancing methodologies and
                outcomes.
              </li>
              <li>
                Enhances employee support and consumer satisfaction for overall
                improvement.
              </li>
            </ul>
          </div>

          <div className="polarian-benifits">
            <h5> ALM-PLM Integration </h5>
            <ul className="custom-bullets">
              <li>
                Quickly react to changing needs by efficiently capturing and
                managing evolving requirements.
              </li>
              <li>
                Boost efficiency through enhanced management of cross-functional
                requirements.{" "}
              </li>
              <li>
                Improve development times with better team collaboration for
                faster cycles.
              </li>
              <li>
                Increase ROI by effectively managing defects and enhancements.
              </li>
              <li>
                Manage traceability to ensure asset visibility throughout all
                lifecycle phases.
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section>
        <div className="solutions container">
          <h4 className="solution-page-heading">Our Solutions</h4>

          <div className="solution-h5">
            <h5>ALM  AS Saas </h5>
            <p className="plmimplementationparagraph">Polarion offers robust solutions for application lifecycle management, ensuring all aspects of the software development process are effectively managed and integrated. </p>
          </div>
          
          <div className="solution-h5">
            <h5>ALM-PLM Integration </h5>
          <p className="plmimplementationparagraph">
          Polarion enables product development organizations to maintain a single, cohesive product ecosystem. With multi-directional linking of ALM and PLM data and processes, it allows for: 
          </p>
          <ul className="custom-bullets">
            <li>Visibility across all assets </li>
            <li>Accurate linking of firmware with hardware </li>
            <li>Traceability of assets for engineers in all lifecycle phases </li>
            <li>Support for maintenance, repair, and operations </li>
          </ul>
        </div>
        </div>
      </section>

      <section style={{ background: "#f5f7fa" }}>
        <div className="why-nextech container">
          <h4 className="solution-page-heading">Why NexTech?</h4>
          <h5 className="solution-subheading">For Polarian ALM Solution</h5>
          <ul className="custom-bullets">
            <li>
              Expert integration for cohesive management of ALM and PLM
              processes.
            </li>
            <li>
              Comprehensive support through all lifecycle phases, from
              development to maintenance.
            </li>
            <li>
              Enhanced collaboration with tools and processes that improve team
              efficiency.
            </li>
            <li>
              ROI optimization through effective management of defects and
              enhancements.
            </li>
            <li>
              Choose NextechPLM for a reliable, efficient, and comprehensive
              Polarion ALM experience.
            </li>
          </ul>
        </div>
      </section>

      <Letsgetintouch />
    </section>
  );
};

export default PolarianALMSolutionPage;
